<style scoped>
  .contact {
    text-align: center;
    margin-top: 45px;
    padding: 0.5rem 1rem;
    margin-bottom: 16px;
  }

  .logo-vertical {
    display: none;
  }

  .logo {
    max-width: 100%;
  }

  img {
    margin-top: 16px;
  }

  .title {
    font-family: rosita, Helvetica, Arial, sans-serif;
    font-size: 3rem;
    letter-spacing: 1px;
    text-transform: capitalize;
  }

  .description {
    text-transform: none;
    font-size: 1rem;
    text-align: center;
    margin: 1rem;
    color: rgba(0, 0, 0, 0.8);
  }

  .contact-data span {
    margin-top: 5px;
  }

  .phone, .email {
    font-weight: bold;
    font-size: 1.2rem;
    margin-top: 10px;
  }

  .contact-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .contact-data {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    font-size: 1rem;
    max-width: 400px;
  }

  @media (min-width: 610px) {
    .contact {
      margin-top: 60px;
    }
    .logo-vertical {
      display: block;
    }

    .logo {
      display: none;
    }

    img {
      margin-top: 0;
    }

    .contact-section {
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;
    }
  }
</style>

<template>
  <div class="contact">
    <section class="contact-section">
      <img class="logo-vertical" src="../assets/logo_vertical.png" alt="logo">
      <img class="logo" src="../assets/logo_horizontal.png" alt="logo">
      <div class="contact-data">
        <span class="description">En No Hay Puntada Sin Hilo estamos encantados de atenderte. Para
          solicitar una cita o cualquier consulta, no dudes en ponerte en contacto con nosotros a través de siguiente
          e-mail.
        </span>
        <span class="email">hola@nohaypuntadasinhilo.com</span>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: 'contact'
}
</script>
